module.exports = __webpack_public_path__ + "asset/image-iconCategoryHousehold-3e35230a42657525.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryHousehold.svg
// module id = 5vIW
// module chunks = 0